import { FC } from 'react';
import { useParams } from 'react-router';
import { Loading } from '../atomic/effects';
import {
    NotificationRequest,
    notificationsAPI,
} from '../../APIs/notificationsAPI';
import { useGet } from '../../hooks/useApi';
import { reformat } from '../../utils/DateUtils';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import React from 'react';
import { NotificationModel } from '../../models/NotificationModel';
import { NotificationLabel } from './NotificationLabel';

type Prop = {
    isPublic: Boolean;
};
export const NotificationShow: FC<Prop> = ({ isPublic }) => {
    const { notificationId } = useParams();
    const { data, isLoading } = useGet(
        notificationId
            ? isPublic
                ? notificationsAPI.public.getSingle(notificationId)
                : notificationsAPI.private.getSingle(notificationId)
            : null
    );
    const notification = data?.data;

    if (!notification) {
        if (isLoading) {
            return <Loading />;
        }
        return (
            <div className="app-main home page-notifications">
                記事が見つかりませんでした
            </div>
        );
    }
    return (
        <div className="app-main home page-notifications">
            <NotificationView notification={notification} />
        </div>
    );
};
type NotificationView = {
    notification: NotificationModel | NotificationRequest;
};
export const NotificationView: FC<NotificationView> = ({ notification }) => {
    return (
        <div className={'preview'}>
            <h1>{notification.title}</h1>
            <div className="notification">
                <div className="metadata">
                    <span className="datetime">
                        {'updatedAt' in notification ? (
                            <>{reformat(notification.updatedAt)}</>
                        ) : (
                            <>YYYY/MM/DD(W) HH:MM</>
                        )}
                    </span>
                    <NotificationLabel type={notification.notificationType} />
                </div>
                <div className="markdown">
                    <Markdown remarkPlugins={[remarkGfm]}>
                        {notification.content}
                    </Markdown>
                </div>
            </div>
        </div>
    );
};
